<template>
    <el-dialog  :title="`${isEdit ? '编辑':'添加'}帐号`" :visible.sync="showDialog">
        <component is="el-form" ref="ruleForm" :rules="rules" :key="preventKey" :model="ruleForm"
                   class="form-beauty form-col"
                   label-width="130px">
            <el-form-item label="姓名" prop="name">
                <el-input v-model.trim="ruleForm.name" :maxlength="50" :disabled="ruleForm.state==1"
                          placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="手机号" prop="mobilephone">
                <el-input v-model.trim="ruleForm.mobilephone" :maxlength="50" :disabled="ruleForm.state==1"
                          placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="一级部门" prop="firDeptName">
                <el-input v-model.trim="ruleForm.firDeptName" :maxlength="50" :disabled="ruleForm.state==1"
                          placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="二级部门" prop="secDeptName">
                <el-input v-model.trim="ruleForm.secDeptName" :maxlength="50" :disabled="ruleForm.state==1"
                          placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="三级部门" prop="thrDeptName">
                <el-input v-model.trim="ruleForm.thrDeptName" :maxlength="50" :disabled="ruleForm.state==1"
                          placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="外包工号" prop="jobNumber">
                <el-input v-model.trim="ruleForm.jobNumber" :maxlength="50" :disabled="ruleForm.state==1"
                          placeholder="请输入"></el-input>
            </el-form-item>
            <el-form-item label="外包公司邮箱" prop="email">
                <el-input v-model.trim="ruleForm.email" :maxlength="50" :disabled="ruleForm.state==1"
                          placeholder="请输入"></el-input>
            </el-form-item>
        </component>
        <div slot="footer" class="mb-10">
            <el-button @click="submitForm('ruleForm', true)">保存</el-button>
            <el-button @click="submitForm('ruleForm', false)" type="primary" v-if="!isEdit">保存并继续添加</el-button>
        </div>
    </el-dialog>
</template>
<script type="text/javascript">
    import selectMapMixin from 'mixins/selectMapMixin'
    import formCommonMixin from 'mixins/formCommonMixin'
    import pattern from 'modules/pattern'
    import rules from 'modules/rules'
    import { dateFormat } from 'modules/tools'

    const Model = {
        id: '',
        name: '',          // 帐号名称
        mobilephone: '',   // 手机号
        firDeptName: '',     // 一级部门
        secDeptName: '',    // 二级部门
        thrDeptName: '',     // 三级部门
        jobNumber: '',      // 外包工号
        email: ''          // 外包邮箱
    }
    export default {
        mixins: [selectMapMixin, formCommonMixin],
        data () {
            return {
                urls: {
                    add: '/bole/save.api',
                    update: '/bole/save.api',
                    fetch: '/bole/getDetailById.api'
                },
                showDialog: false,
                isEdit: false,
                preventKey: 1,
                ruleForm: Object.assign({}, Model),
                rules: {
                    name: {required: true, message: '请输入姓名', trigger: 'blur'},
                    mobilephone: [
                        {required: true, message: '请输入手机号', trigger: 'blur'},
                        {pattern: pattern.phone, message: '手机号格式不正确', trigger: 'blur'}
                    ],
                    email: [
                        {required: true, message: '请输入', trigger: 'blur'},
                        {type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur'}
                    ],
                    firDeptName: {required: true, message: '请输入一级部门', trigger: 'blur'},
                    secDeptName: {required: true, message: '请输入二级部门', trigger: 'blur'},
                    thrDeptName: {required: true, message: '请输入三级部门', trigger: 'blur'},
                    jobNumber: {required: true, message: '请输入外包工号', trigger: 'blur'}
                }
            }
        },
        methods: {
            show (data) {
                this.preventKey++
                if (data) {
                    this.fetchData(data.id)
                } else {
                    this.ruleForm.id = ''
                }
                this.isEdit = Boolean(data && data.id)
                this.$refs.ruleForm && this.$refs.ruleForm.resetFields()
                this.showDialog = true
            },
            saveForm (boolean) {
                // 提交表单
                this.$axios.post(this.ruleForm.id ? this.urls.update : this.urls.add, this.ruleForm, {'X-showMessage': true}).then(res => {
                    this.resetForm('ruleForm')
                    if (boolean === true) {
                        this.showDialog = false
                    } else {
                        this.ruleForm.id = ''
                    }
                    this.$emit('reload')
                }).catch(() => {})
            },
            fetchData (id) {
                this.$axios.get(this.urls.fetch, {params: {id: id}}).then(res => {
                    let data = res.result.bean

                    Object.keys(this.ruleForm).forEach(key => {
                        this.ruleForm[key] = data[key]
                    })
                })
            }
        }
    }
</script>
<style type="text/css" lang="scss">

</style>


// WEBPACK FOOTER //
// addBoleDialog.vue?76e57ba9